module.exports = __webpack_public_path__ + "static/media/title-hero-5.fe77ad16.jpg";